import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { UploadFileBase } from '@/components/ui/Form/UploadFile/UploadFileBase';
import { UploadFileText } from '@/components/ui/Form/UploadFile/UploadFileText';
/**
 * アップロードファイルを表示するためのリンクコンポーネント
 * @description 特に認証などの必要がない通常ファイル表示で使用する想定
 * @param props
 * @constructor
 */
export const UploadFileLink = (props) => {
    const { className = '', fileLink, fileName, hasUploadError, isDeletable, isUploading, onClickDelete, textSize, } = props;
    const isNoLink = !fileLink || hasUploadError || isUploading;
    return (_jsx(UploadFileBase, Object.assign({ className: className, isDeletable: isDeletable, isUploading: isUploading, onClickDelete: onClickDelete }, { children: _jsx(DynamicLink, Object.assign({ className: 'flex text-left', noLinkElement: isNoLink ? 'div' : undefined, target: '_blank', to: fileLink || '' }, { children: _jsx(UploadFileText, { disabled: isNoLink, fileName: fileName, textSize: textSize }) })) })));
};
